import forms from '@tailwindcss/forms';
import { rwColors } from './src/styles/colors';

/** @type {import('tailwindcss').Config} */
export default {
  content: ['./index.html', './src/**/*.{js,ts,jsx,tsx}'],
  theme: {
    extend: {
      backgroundImage: {
        simple: "url('/images/background-simple.png')",
        themes: "url('/images/background-themes.webp')",
      },
      colors: {
        'primary-teal': '#377E7F',
        'primary-light-teal': '#ECF8F9',
        'primary-dark-teal': '#0C4E52',
        'primary-chic-teal': '#052C38',
        rw: rwColors,
      },
      lineClamp: { 15: '15' },
    },
  },
  plugins: [forms],
};
